import { render, staticRenderFns } from "./BubblePreview.vue?vue&type=template&id=1045ec1c&scoped=true"
import script from "./BubblePreview.vue?vue&type=script&lang=js"
export * from "./BubblePreview.vue?vue&type=script&lang=js"
import style0 from "./BubblePreview.vue?vue&type=style&index=0&id=1045ec1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045ec1c",
  null
  
)

export default component.exports